import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const OverbygningPilVenstre: React.FC<SvgProps> = ({ pathFill = '#077197', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 102 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				id='Vector 102'
				d='M0.000198364 19.5002L5.03428 22.3271L4.96541 16.554L0.000198364 19.5002ZM100.499 0C100.499 7.39884 98.282 13.0065 94.4015 16.7659C90.5184 20.5279 84.9067 22.5 78 22.5V23.5C85.0931 23.5 90.9809 21.4721 95.0973 17.4841C99.2164 13.4935 101.499 7.60116 101.499 0H100.499ZM78 22.5C71.2482 22.5 68.0109 18.6815 64.3699 14.6642C62.5585 12.6656 60.6415 10.6162 58.1529 9.07492C55.6511 7.52547 52.5909 6.5 48.4988 6.5V7.5C52.4067 7.5 55.2842 8.47453 57.6264 9.92508C59.9818 11.3838 61.8151 13.3344 63.629 15.3358C67.2387 19.3185 70.752 23.5 78 23.5V22.5ZM48.4988 6.5C44.5796 6.5 42.0661 7.23846 39.9423 8.3797C38.8899 8.94524 37.943 9.60444 36.9839 10.2997C36.0194 10.9988 35.047 11.7309 33.9126 12.4724C29.4238 15.4066 22.3711 18.505 4.48844 18.9467L4.51313 19.9464C22.5141 19.5018 29.7671 16.3769 34.4597 13.3094C35.6207 12.5506 36.6234 11.796 37.5708 11.1093C38.5236 10.4187 39.4254 9.79267 40.4156 9.26058C42.3771 8.20657 44.7246 7.5 48.4988 7.5V6.5Z'
				fill={pathFill}
			/>
		</svg>
	);
};
